export default __webpack_public_path__ + "static/media/black-traind-Icon.9a205a62.svg";